import { modalStore } from '../stores';

import { mount, unmount } from '.';

export const openNewTaskForm = (): void => {
  modalStore.set({
    open: true,
    prevAction: '',
  });

  mount();
};

export const setPrevAction = (action: string): void => {
  modalStore.set({
    ...(modalStore.value as any),
    prevAction: action,
  });
};

export const closeForm = (): void => {
  modalStore.set({
    ...(modalStore.value as any),
    open: false,
  });
  setTimeout(() => {
    unmount();
  }, 500);
};
